export default __webpack_public_path__ + "static/media/mode-511.f5f5fdf0.svg";